import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

export default function ParkCard({ parkCode, fullName, states, images }: any) {
  return (
    <Link
      to={`/park/${parkCode}`}
      className="my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/4"
    >
      <article className="overflow-hidden h-full rounded-lg shadow-lg">
          <LazyLoad height={600} offset={800} once>
            <img
              alt="Placeholder"
              className="block h-auto w-full"
              src={`http://imgresizr.tk/?url=${images[0]?.url}&width=600&height=400&quality=75`}
            ></img>
          </LazyLoad>

        <header className="flex items-center justify-between leading-tight p-2 h-12">
          <h1 className="text-lg">
              {fullName}
          </h1>
        </header>

        <footer className="flex items-center justify-between leading-none p-2">

            <p className="text-sm">{states}</p>

          
            <span className="hidden">Like</span>
            <i className="fa fa-heart"></i>
      
        </footer>
      </article>
    </Link>
  );
}
